import { render } from "./ReviewSearch.vue?vue&type=template&id=da23e376&scoped=true"
import script from "./ReviewSearch.vue?vue&type=script&lang=js"
export * from "./ReviewSearch.vue?vue&type=script&lang=js"

import "./ReviewSearch.vue?vue&type=style&index=0&id=da23e376&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da23e376"]])

export default __exports__